<template>
  <skud-audit-list />
</template>

<script>
import SkudAuditList from '@/views/skud/components/SkudAuditList.vue'

export default {
  name: 'SkudAuditListPage',
  components: { SkudAuditList }
}
</script>
